import React, {Component} from 'react';

class Photos extends Component {

  render() {
    return (

      <section>
      <div className="Wrapper">
        <div className="Content">
          <h2>BIO</h2>
            <p>Patrik Sas (born February 14, 1989) was raised in Ostrava, Northern Moravia, Czech Republic but currently lives in Prague.
            </p>
            <p>He began playing drums at age eight, grew up in a musical family and studied percussion at the Janacek’s conservatory in Ostrava. He also studied drums in the United States namely New York and Los Angeles. He has taken lessons from drumming superstar Thomas Lang among others. Patrik is one of the best employed session drummers in Czech Republic able to take on various styles from rock across pop to metal.
            </p>
            <p>Despite his youth, have managed to play with such prominent figures of the czech music scene. For a great experience also considered playing with Suzanne Vega and guitarist Gerry Leonard (David Bowie)
            </p>
            <p>In 2014 he won the first prize in the American global music contest in the category BEST SOLO PERFORMANCE. His drum performance was selected as a judge’s pick. The judges were Billy Sheehan(Mr. Big, The Winery Dogs,) Bumblefoot(Guns’N’Roses, Sons of Appolo) and record producer Drew Lane.
            </p>
            <p>Patrik is known for his technical and rhythmic heavy precision drumming with extended double-bass blasts, mid-tempo rock power grooves, precision tom fills, jazzy drum breaks, and blast beats. 
            </p>
            <p><strong>He also plays and proudly endorses Tama drums, Roland V-drums, Paiste cymbals and Balbex drumsticks.</strong>
            </p>
      </div>
      </div>
    </section>);
  }
}

export default Photos;



// WEBPACK FOOTER //
// ./src/pages/About.js